module.exports = __webpack_public_path__ + "img/area-9-2.d78a0bf.jpg";